<script>
  import { Line } from 'vue-chartjs';
  import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
  import { hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities';
  import {isEmpty} from "@/utils/fileHelper";

  export default {
    name: "LineCharts",
    components: {
      hexToRgba,
      CustomTooltips
    },
    props: [
      'datas',
      'height',
      'width',
    ],
    extends: Line,
    data () {
      return {
        isEmpty
      }
    },
    mounted () {
      let self = this;
      let dataSets = [];
      let labels = [];
      let type = this.datas.type
      let bpij = this.datas.bpij

      if (!isEmpty(this.datas)) {
        labels = this.datas.labels
        for (let data of this.datas.datas) {
          dataSets.push({
            label: data.label,
            backgroundColor: hexToRgba(data.backgroundColor, 90),
            data: data.data
          });
        }
      } else {
        dataSets = [{label: '', backgroundColor: '#FFFFFF', data: []}];
      }

      function getSirenStatsDetail(value) {
        self.$event.emit('getStatsDetail', {value: value, labels: labels, type: type, bpij: bpij})
      }

      function getMin() {
        return dataSets.reduce((res, set) => {
          return res !== null && res < Math.min(...set.data) ? res : Math.min(...set.data);
        }, null);
      }

      function getMax() {
        return dataSets.reduce((res, set) => {
          return res !== null && res > Math.max(...set.data) ? res : Math.max(...set.data);
        }, null);
      }

      this.renderChart(
        {
          labels: labels,
          datasets: dataSets
        },
        {
          responsive: true,
          height: '50%',
          maintainAspectRatio: false,
          onClick: function(evt, value) {
            if (type === 'declaration' || type === 'traitement') {
              getSirenStatsDetail(value);
            }
          },
          tooltips: {
            enabled: false,
            custom: CustomTooltips,
            intersect: true,
            mode: 'index',
            position: 'nearest',
            callbacks: {
              labelColor: function (tooltipItem, chart) {
                return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
              },
              label: function (context,chart) {
                let label = chart.datasets[context.datasetIndex].label || '';

                if (label) {
                    label += ': ';
                }
                if (context.value !== null) {
                    label += context.value + ' j';
                }
                return label;
              },
            }
          },
          scales: {
            xAxes: [
              {
                display: true,
                gridLines: {
                  // offset: true,
                  // zeroLineColor: 'transparent'
                },
                // ticks: {
                //   fontSize: 2,
                //   fontColor: 'transparent'
                // }
              }
            ],
            yAxes: [
              {
                display: true,
                ticks: {
                  callback: function(val, index) {
                    // Hide every 2nd tick label
                    return index % 2 === 0 ? val : '';
                  },
                  display: true,
                  min: (getMin() - 4) > 0 ? getMin() - 4 : 0,
                  max: getMax() //+ Math.floor(5 * getMax() / 100)
                }
              }
            ]
          },
        }
      )
    },
    methode: {
    }
  }
</script>
